export const pinColumnWidth = 125;
